import React from 'react';
import Icon from '../../../components/AppIcon';

const HighlightsSection = () => {
  const highlights = [
    {
      id: 1,
      title: 'Award-Winning Innovation',
      body: 'Recognized by Vienna Business Agency and FFG for groundbreaking technology in remote hardware access.',
      icon: 'Award',
      color: 'var(--color-accent)'
    },
    {
      id: 2,
      title: 'Industry Partnerships',
      body: 'Collaborating with ARM, NXP, and TU Wien to shape the future of hardware development workflows.',
      icon: 'Users',
      color: 'var(--color-primary)'
    }
  ];

  return (
    <section className="py-24 px-4 md:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {highlights?.map((highlight) => (
            <div
              key={highlight?.id}
              className="bg-card border border-border rounded-lg p-6 md:p-8 transition-all duration-300 hover:border-primary/50"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-3">
                    {highlight?.title}
                  </h3>
                </div>
                <div 
                  className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ background: `${highlight?.color}15` }}
                >
                  <Icon name={highlight?.icon} size={24} color={highlight?.color} />
                </div>
              </div>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                {highlight?.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;